import router from '@/router/index';
import { Message } from 'element-gui';
import service from '@/request/service';
import toolbar from './toolbar';
import * as types from '../mutation-types';

const state = {
  userInfo: {}, // 用户信息
  currentServerDateTime: 0, // 服务器时间戳
  startDate: '', // 开始日期
  endDate: '', //结束日期
  industryList: [], // 行业列表
  industryName: '', //行业类型
  professionList: [], // 专业列表
  professionTypeName: '', // 专业类型
  projectStateList: [], //项目状态列表
  projectState: '', //项目状态
  keywords: '', // 关键字
  pageIndex: 1,
  pageSize: 10,
  pageTotal: 0, // 列表总数
  bidSectionHeaderList: [],
  projectHeaderList: [],
  projectList: [], // 历史项目列表
  historyLoading: false, // 历史项目列表loading效果
  currentBidSection: '', //当前选择的标段
  currentBidSectionList: [], //当前选择的标段组
  obj: [],
  stageObj: {
    stage: 0,
  },
  singleLoginFlag: false,
  singleLoginLoading: true,
  singleLoginBidId: '',
  singleLoginObj: {
    projectCode: '',
    bidSectionCode: '',
    reTenderCount: -1, // 重新招标次数
    isQualificationE: 0 //是否为资审电子标，0:否，1:是
  }
};
const getters = {
  userName: (state) => state.userInfo.userName || '',
  getMenu: (state) => state.obj,
  getStage: (state) => state.stageObj,
};
const actions = {
  async setStage({ commit }, obj) {
    commit(types.GET_STAGE_STATUS, obj);
  },
  // 退出
  handleLogOut() {
    service({
      url: '/user/logout',
      method: 'post',
    }).then((response) => {
      console.log(response);
      if (response.code == 200) {
        window.sessionStorage.clear();
        router.push({ path: '/login' });
      } else {
        Message({
          message: response.msg,
          type: 'error',
        });
      }
    });
  },
  // 获取服务器时间
  getServerTime({ commit }) {
    service
      .get('/tools/getCurrentServerDate')
      .then(({ data, code, errorMsg }) => {
        if (code !== 200) {
          Message({
            message: errorMsg,
            type: 'error',
          });
          return;
        }
        const timeStamp = data.timeStamp;
        commit('CURRENTDATETIME', timeStamp);
      });
  },
  async findPageTemplate({ commit }) {
    const { data: projectHeader } = await service.post(
      '/pageTemplate/findPageTemplate',
      {
        tempName: '开标历史项目列表-项目',
      }
    );
    const { cols: projectHeaderList } = projectHeader.contentText || [];
    commit('PROJECTHEADERLIST', projectHeaderList);
  },
  // 获取项目历史列表
  async getHistoryList({ state, commit }) {
    const { data: bidSectionHeader } = await service.post(
      '/pageTemplate/findPageTemplate',
      {
        tempName: '开标历史项目列表-标段',
      }
    );
    const { cols: bidSectionHeaderList } = bidSectionHeader.contentText || [];
    commit('BIDSECTIONHEADERLIST', bidSectionHeaderList);
    commit('HISTORYLOADING', true);
    service
      .post('/projectlist/history/list', {
        beginTime: state.startDate,
        endTime: state.endDate,
        industryName: state.industryName,
        keywords: state.keywords,
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        professionTypeName: state.professionTypeName,
        projectState: state.projectState,
        roleType: state.userInfo.userType,
        userCode: state.userInfo.userId,
      })
      .then(({ data, code }) => {
        if (code !== 200) {
          Message({
            message: data.msg,
            type: 'error',
          });
        } else {
          const projectList = data.projectList || [];
          const array = JSON.parse(JSON.stringify(bidSectionHeaderList));
          const list = JSON.parse(JSON.stringify(bidSectionHeaderList));
          for (let da of projectList) {
            array.forEach((item) => {
              if (item.elementKey === 'bidSectionCode')
                item.elementName = '标段编号';
              if (item.elementKey === 'bidSectionName')
                item.elementName = '标段名称';
              if (item.elementKey === 'tenderName') item.elementName = '招标人';
              if (item.elementKey === 'tenderAgencyName')
                item.elementName = '招标代理';
            });
            list.forEach((item) => {
              if (item.elementKey === 'bidSectionCode')
                item.elementName = '标包编号';
              if (item.elementKey === 'bidSectionName')
                item.elementName = '标包名称';
              if (item.elementKey === 'tenderName') item.elementName = '采购人';
              if (item.elementKey === 'tenderAgencyName')
                item.elementName = '采购代理';
            });
            if (da.industryName === '政府采购') {
              da.headList = list;
            } else {
              da.headList = array;
            }
          }
          commit('PROJECTLIST', projectList);
          commit('HISTORYLOADING', false);
          commit('PAGETOTAL', data.pageTotal);
        }
      });
  },
  // 更新项目历史列表
  async updateProjectList({ state, commit, dispatch }) {
    const { data: bidSectionHeader } = await service.post(
      '/pageTemplate/findPageTemplate',
      {
        tempName: '开标历史项目列表-标段',
      }
    );
    const { cols: bidSectionHeaderList } = bidSectionHeader.contentText || [];
    commit('BIDSECTIONHEADERLIST', bidSectionHeaderList);
    commit('CURRENTBIDSECTIONLIST', []);
    commit('HISTORYLOADING', true);
    console.log(state, 'state-11');
    service
      .post('/projectlist/history/list', {
        beginTime: state.startDate,
        endTime: state.endDate,
        industryName: state.industryName,
        keywords: state.keywords,
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        professionTypeName: state.professionTypeName,
        projectState: state.projectState,
        roleType: state.userInfo.userType,
        userCode: state.userInfo.userId,

        projectCode: state.singleLoginFlag ? state.singleLoginObj.params.projectCode : null,
        bidSectionCode: state.singleLoginFlag ? state.singleLoginObj.params.bidSectionCode : null,
      })
      .then(({ data }) => {
        const projectList = data.projectList || [];
        const array = JSON.parse(JSON.stringify(bidSectionHeaderList));
        const list = JSON.parse(JSON.stringify(bidSectionHeaderList));
        for (let da of projectList) {
          array.forEach((item) => {
            if (item.elementKey === 'bidSectionCode')
              item.elementName = '标段编号';
            if (item.elementKey === 'bidSectionName')
              item.elementName = '标段名称';
            if (item.elementKey === 'tenderName') item.elementName = '招标人';
            if (item.elementKey === 'tenderAgencyName')
              item.elementName = '招标代理';
          });
          list.forEach((item) => {
            if (item.elementKey === 'bidSectionCode')
              item.elementName = '标包编号';
            if (item.elementKey === 'bidSectionName')
              item.elementName = '标包名称';
            if (item.elementKey === 'tenderName') item.elementName = '采购人';
            if (item.elementKey === 'tenderAgencyName')
              item.elementName = '采购代理';
          });
          if (da.industryName === '政府采购') {
            da.headList = list;
          } else {
            da.headList = array;
          }
        }
        const row = state.currentBidSection;
        const { bidSectionId, unionSection, domainId } = row;
      //判断是否是因单点登录，查询的历史列表 singleLoginFlag：true--是
        if (state.singleLoginFlag) {
          commit('KEYWORDS', '');
          let emptyProjectFlag = true;
          projectList.forEach((item) => {
            if (item.projectCode == state.singleLoginObj.params["projectCode"]) {
              const sectionList = item.sectionList || [];
              sectionList.forEach((ite) => {
                if (
                  ite.bidSectionCode == state.singleLoginObj.params["bidSectionCode"]
                  ) {
                  emptyProjectFlag = false;
                  commit('SINGLELOGINBIDID', ite.bidSectionId);
                  commit('PROJECTLIST', [item]);
                  dispatch('handleOpenBid', ite);
                }
              });
            }
          });
          if (emptyProjectFlag) {
            commit('SINGLELOGINLOADING', false);
            commit('SINGLELOGINFLAG', false);
            dispatch('singleLoginFailedMsg');
          }
        } else {
          projectList.forEach((item) => {
            const sectionList = item.sectionList || [];
            sectionList.forEach((ite, index) => {
              sectionList[index] = { ...ite, isChecked: false };
              if (ite.bidSectionId === bidSectionId) {
                sectionList[index] = { ...ite, isChecked: true };
                commit('CURRENTBIDSECTIONLIST', [
                  ...state.currentBidSectionList,
                  ite,
                ]);
              }
              if (
                unionSection &&
                ite.domainId === domainId &&
                ite.bidSectionId !== bidSectionId
              ) {
                commit('CURRENTBIDSECTIONLIST', [
                  ...state.currentBidSectionList,
                  ite,
                ]);
                sectionList[index] = { ...ite, isChecked: true };
              }
            });
          });
          commit('PROJECTLIST', projectList);
          commit('PAGETOTAL', data.pageTotal);
        }
        commit('HISTORYLOADING', false);
      });
  },
  // 获取行业列表
  getIndustryList({ commit }) {
    service.post('/projectlist/industry/list').then(({ data, code }) => {
      if (code !== 200) {
        Message({
          message: data.msg,
          type: 'error',
        });
      } else {
        commit('INDUSTRYLIST', data.list);
      }
    });
  },
  // 获取专业列表
  getProfessionList({ commit }) {
    service.post('/projectlist/profession/list').then(({ data, code }) => {
      if (code !== 200) {
        Message({
          message: data.msg,
          type: 'error',
        });
      } else {
        commit('PROFESSIONLIST', data.list);
      }
    });
  },
  // 获取项目状态列表
  getProjectStateList({ commit }) {
    service.post('/projectlist/project/status/list').then(({ data, code }) => {
      if (code !== 200) {
        Message({
          message: data.msg,
          type: 'error',
        });
      } else {
        commit('PROJECTSTATELIST', data.list);
      }
    });
  },
  handleOpenBid({ state, commit, dispatch }, payload) {
    commit('CURRENTBIDSECTIONLIST', []);
    const list = state.projectList || [];
    commit('CURRENTBIDSECTION', payload);
    const row = state.currentBidSection;
    service
      .get('/prepare/getBidderId/' + state.currentBidSection.bidSectionId, {
        params: { bidSectionId: state.currentBidSection.bidSectionId },
      })
      .then((r) => {
        if (state.singleLoginFlag) {
          commit('SINGLELOGINLOADING', false);
        }
        if (r.code === 200) {
          dispatch(
            'toolbar/getTendCtrlPriceInfo',
            { visible: false },
            { root: true }
          );
          const { bidSectionId, unionSection, domainId } = row;
          // 复制bidderId，开标人为空，投标人为当前投标人的bidderId
          // 当前条目复制bidderId
          if (r.data && r.data.split('_').length > 2) {
            row['bidderId'] = r.data.split('_')[0];
            row['bidderName'] = r.data.split('_')[1];
            row['invalidStatus'] = r.data.split('_')[2]
          } else {
            row['bidderId'] = '';
            row['bidderName'] = '';
            row['invalidStatus'] = '1'
          }
          commit('CURRENTBIDSECTION', row);
          // 整个domainList复制bidderId
          list.forEach((item) => {
            const sectionList = item.sectionList || [];
            if (r.data && r.data.split('_').length > 2) {
              row['bidderId'] = r.data.split('_')[0];
              row['bidderName'] = r.data.split('_')[1];
              row['invalidStatus'] = r.data.split('_')[2]
            } else {
              row['bidderId'] = '';
              row['bidderName'] = '';
              row['invalidStatus'] = '1'
            }
            sectionList.forEach((ite, index) => {
              sectionList[index] = { ...ite, isChecked: false };

              if (ite.bidSectionId === bidSectionId) {
                sectionList[index] = { ...ite, isChecked: true };
                commit('CURRENTBIDSECTIONLIST', [
                  ...state.currentBidSectionList,
                  ite,
                ]);
              }
              if (
                unionSection &&
                ite.domainId === domainId &&
                ite.bidSectionId !== bidSectionId
              ) {
                commit('CURRENTBIDSECTIONLIST', [
                  ...state.currentBidSectionList,
                  ite,
                ]);
                sectionList[index] = { ...ite, isChecked: true };
              }
            });
          });
          sessionStorage.setItem(
            'row',
            JSON.stringify(state.currentBidSectionList)
          );
          commit('INDUSTRYNAME',state.currentBidSectionList[0].industryName)
          let excluUrl = [];
          if (sessionStorage.getItem('roleKey') == '2') {
            excluUrl = ['/index/bidOpen'];
            if (state.currentBidSection.region == '山西') {
              excluUrl = ['/index/bidOpen', '/index/pubBidder'];
            }
          }
          service
            .post('/project/openReady/getJumpUrl', {
              bidSectionId: state.currentBidSection.bidSectionId,
              excludUrl: excluUrl,
            })
            .then((data) => {
              if (data.code === 200) {
                dispatch('getMenuStatus', {
                  bidSectionId: state.currentBidSection.bidSectionId,
                  data: data.data,
                });
              } else {
                Message({
                  message: data.msg,
                  type: 'error',
                });
              }
            });
        } else {
          Message.error({
            message: r.msg,
            iconClass: 'el-icon-circle-cross1',
          });
        }
      });
  },
  // 无阶段导航
  getMenuStatus({ commit, dispatch }, obj) {
    service
      .get('/project/openReady/getMenuList', {
        params: { bidSectionId: obj.bidSectionId },
      })
      .then((res) => {
        if (res.code === 200) {
          if (res.data.list.length) {
            // 投标人不需要开标准备
            if (window.sessionStorage.getItem('roleKey') == '2') {
              if (res.data.list[0].menus[0].type === '开标准备') {
                res.data.list[0].menus.shift();
              }
              if (
                ['山西','福建','新疆','浙江','全国'].includes(JSON.parse(window.sessionStorage.getItem('row'))[0].region)
              ) {
                res.data.list[0].menus.forEach(function (item, index) {
                  if (item.type === '公布投标人名单') {
                    // res.data.list[0].menus.splice(index, 1);
                    sessionStorage.setItem('menuName', item.menuName);
                  }
                });
              }
            }
            // 重构数据 单阶段
            if (res.data.list.length === 1) {
            //   let obj1 = {
            //   icon: "signatureList",
            //   index: 7,
            //   isLeaf: true,
            //   menuName: '特征码一览表',
            //   path: "/index/signatureList",
            //   status: 0,
            //   type: "特征码一览表",
            //   url: "/index/signatureList",
            // };
            // let obj2 = {
            //   icon: "finalists",
            //   index: 8,
            //   isLeaf: true,
            //   menuName: '入围名单',
            //   path: "/index/finalists",
            //   status: 0,
            //   type: "入围名单",
            //   url: "/index/finalists",
            // }
            // res.data.list[0].menus.splice(-1, 0, obj1 ,obj2)
            // if (window.sessionStorage.getItem('roleKey') == '2') {
            //   res.data.list[0].menus.forEach(function (item, index) {
            //     if (item.type === '特征码一览表') {
            //       res.data.list[0].menus.splice(index, 1);
            //     }
            //   });
            // }

            // let obj1 = {
            //   icon: "signatureList",
            //   index: 7,
            //   isLeaf: true,
            //   menuName: '投标单位入围',
            //   path: "/index/openbidderEnter",
            //   status: 0,
            //   type: "投标单位入围",
            //   url: "/index/openbidderEnter",
            // };
            // let obj2 = {
            //   icon: "signatureList",
            //   index: 8,
            //   isLeaf: true,
            //   menuName: '随机赋码', 
            //   path: "/index/bidderRandomCode",
            //   status: 0,
            //   type: "随机赋码",
            //   url: "/index/bidderRandomCode",
            // }
            // res.data.list[0].menus.splice(4, 0, obj1, obj2)

            if (JSON.parse(window.sessionStorage.getItem('obj')).userType == '2' ) { 
              res.data.list[0].menus.forEach(function (item, index) {
                if (item.type === '随机抽球法-投标单位入围') {
                  res.data.list[0].menus.splice(index, 1);
                }
              });
              res.data.list[0].menus.forEach((item,index)=>{
                item.index = index+2
              })
            }

            
              res.data.list[0].menus.forEach(function (item) {
                item.path = item.url; //复制url
                item.stage = res.data.list[0].stage;
                switch (item.type) {
                  case '开标准备':
                    item.isLeaf = true;
                    item.icon = 'raw';
                    break;
                  case '公布投标人名单':
                    item.isLeaf = true;
                    item.icon = 'pre';
                    break;
                  case '投标文件解密':
                    item.isLeaf = true;
                    item.icon = 'file';
                    break;
                  case '唱标':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '随机抽球法-投标单位入围':
                    item.isLeaf = true;
                    item.icon = 'openbidderEnter';
                    break;
                  case '随机抽球法-随机赋码':
                    item.isLeaf = true;
                    item.icon = 'bidderRandomCode';
                    break;
                  case '系数抽取':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '特征码一览表':
                    item.isLeaf = true;
                    item.icon = 'signatureList';
                    break;
                  case '入围名单':
                    item.isLeaf = true;
                    item.icon = 'finalists';
                    break;
                  case '抽取参数':
                    item.isLeaf = true;
                    item.icon = 'extract';
                    break;
                  case '计算结果':
                    item.isLeaf = true;
                    item.icon = 'result';
                    break;
                  case '抽取中标候选人':
                    item.isLeaf = true;
                    item.icon = 'extractBidder';
                    break;
                  case '开标结束':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                  case '替补中标候选人':
                    item.isLeaf = true;
                    item.icon = 'alternate';
                    break;
                  case '评审结果':
                    item.isLeaf = true;
                    item.icon = 'evalResult';
                    break;
                }
              });
              commit(
                types.GET_MENU_STATUS,
                Array.isArray(res.data.list[0].menus)
                  ? res.data.list[0].menus
                  : []
              );
              // 单阶段组装导航数据
              res.data.list[0].menus.forEach(function (item, index) {
                // 添加省略符
                if (item.menuName.split('').length > 5) {
                  item.name = item.menuName.split('').slice(0, 5);
                  item.name.splice(5, null, ' ...');
                } else {
                  item.name = item.menuName.split('');
                }
              });
              res.data.list[0].menus = res.data.list[0].menus.filter(
                (item, index) => index < 5
              );
              window.sessionStorage.setItem(
                'menuTrue',
                JSON.stringify(res.data.list[0].menus)
              );
              window.sessionStorage.setItem(
                'currentMenuTrue',
                JSON.stringify(res.data.list[0].menus[0])
              );
              dispatch('setStage', {
                stage: res.data.list[0].stage,
              });
            } else {
              res.data.list[0].menus.forEach(function (item) {
                item.path = item.url; //复制url
                item.stage = res.data.list[0].stage;
                switch (item.type) {
                  case '开标准备':
                    item.isLeaf = true;
                    item.icon = 'raw';
                    break;
                  case '公布投标人名单':
                    item.isLeaf = true;
                    item.icon = 'pre';
                    break;
                  case '投标文件解密':
                    item.isLeaf = true;
                    item.icon = 'file';
                    break;
                  case '唱标':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '系数抽取':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '特征码一览表':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                  case '入围名单':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                  case '抽取结果':
                    item.isLeaf = true;
                    item.icon = 'extract';
                    break;
                  case '计算结果':
                    item.isLeaf = true;
                    item.icon = 'result';
                    break;
                  case '抽取中标候选人':
                    item.isLeaf = true;
                    item.icon = 'extractBidder';
                    break;
                  case '开标结束':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                  case '替补中标候选人':
                    item.isLeaf = true;
                    item.icon = 'alternate';
                    break;
                }
              });
              res.data.list[1].menus.forEach(function (item) {
                item.path = item.url; //复制url
                item.stage = res.data.list[1].stage;
                switch (item.type) {
                  case '公布第一信封评审结果':
                    item.isLeaf = true;
                    item.icon = 'pre';
                    break;
                  case '二信封唱标':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '系数抽取':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '评标基准价':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '二信封开标结束':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                }
              });
              let result = [];
              for (let data of res.data.list[0].menus.concat(
                res.data.list[1].menus
              )) {
                result.push(data);
              }
              commit(
                types.GET_MENU_STATUS,
                Array.isArray(result) ? result : []
              );
              // 多阶段组装导航数据
              result.forEach(function (item, index) {
                // 添加省略符
                if (item.menuName.split('').length > 5) {
                  item.name = item.menuName.split('').slice(0, 5);
                  item.name.splice(5, null, ' ...');
                } else {
                  item.name = item.menuName.split('');
                }
              });
              result = result.filter((item, index) => index < 5);
              window.sessionStorage.setItem('menuTrue', JSON.stringify(result));
              window.sessionStorage.setItem(
                'currentMenuTrue',
                JSON.stringify(result[0])
              );
              dispatch('setStage', {
                stage: result[0].stage,
              });
            }
          }
        } else {
          Message.error({
            message: res.data.msg,
            iconClass: 'el-icon-circle-cross1',
          });
        }
        if (obj.data) {
          router.push({ path: obj.data });
        } else {
          if (window.sessionStorage.getItem('roleKey') == '1') {
            router.push({ path: '/index/bidOpen' });
          } else {
            router.push({ path: '/index/pubBidder' });
          }
        }
      });
  },
  handleNegotiation({ state, commit }, payload) {
    commit('CURRENTBIDSECTIONLIST', []);
    commit('CURRENTBIDSECTION', payload);
    const list = state.projectList || [];
    const row = state.currentBidSection;
    console.log(row);
    const { bidSectionId, unionSection, domainId } = row;
    list.forEach((item) => {
      const sectionList = item.sectionList || [];
      sectionList.forEach((ite, index) => {
        sectionList[index] = { ...ite, isChecked: false };

        if (ite.bidSectionId === bidSectionId) {
          sectionList[index] = { ...ite, isChecked: true };
          commit('CURRENTBIDSECTIONLIST', [
            ...state.currentBidSectionList,
            ite,
          ]);
        }
        if (
          unionSection &&
          ite.domainId === domainId &&
          ite.bidSectionId !== bidSectionId
        ) {
          commit('CURRENTBIDSECTIONLIST', [
            ...state.currentBidSectionList,
            ite,
          ]);
          sectionList[index] = { ...ite, isChecked: true };
        }
      });
    });

    sessionStorage.setItem('row', JSON.stringify(state.currentBidSectionList));
    service
      .get('/prepare/getBidderId/' + state.currentBidSection.bidSectionId, {
        params: { bidSectionId: state.currentBidSection.bidSectionId },
      })
      .then((res) => {
        if (res.code === 200) {
          service
            .post('/bidsection/getBidSectionBriefList', {
              id: state.currentBidSectionList[0].domainId,
              bidSectionIds: state.currentBidSectionList.map(
                (item) => item.bidSectionId
              ),
            })
            .then((r) => {
              if (r.code === 200) {
                const params = state.currentBidSectionList;
                params[0]['bidderId'] = res.data.split('_')[0];
                params[0]['bidderName'] = res.data.split('_')[1];
                params[0]['openbidId'] =
                  r.data.list[0].openBidList[0].openBidId || '';
                sessionStorage.setItem('row', JSON.stringify(params));
                router.push({ path: '/bidder/consult' });
              }
            });
        } else {
          Message.error({
            message: res.data.msg,
            iconClass: 'el-icon-circle-cross1',
          });
        }
      });
  },
  singleLoginFailedMsg(){
    Message({ message: '暂未查询到项目信息，无法登录系统', type: 'warning' });
  }
};
const mutations = {
  USERINFO(state, payload) {
    state.userInfo = payload;
  },
  CURRENTDATETIME(state, payload) {
    state.currentServerDateTime = payload;
  },
  PROJECTHEADERLIST(state, payload) {
    state.projectHeaderList = payload;
  },
  BIDSECTIONHEADERLIST(state, payload) {
    state.bidSectionHeaderList = payload;
  },
  PROJECTLIST(state, payload) {
    state.projectList = payload;
  },
  PAGETOTAL(state, payload) {
    state.pageTotal = payload;
  },
  CURRENTBIDSECTION(state, payload) {
    state.currentBidSection = payload;
  },
  CURRENTBIDSECTIONLIST(state, payload) {
    state.currentBidSectionList = payload;
  },
  INDUSTRYLIST(state, payload) {
    state.industryList = payload;
  },
  PROFESSIONLIST(state, payload) {
    state.professionList = payload;
  },
  PROJECTSTATELIST(state, payload) {
    state.projectStateList = payload;
  },
  INDUSTRYNAME(state, payload) {
    state.industryName = payload;
  },
  PROFESSIONNAME(state, payload) {
    state.professionTypeName = payload;
  },
  PROJECTSTATE(state, payload) {
    state.projectState = payload;
  },
  KEYWORDS(state, payload) {
    state.keywords = payload;
  },
  STARTDATE(state, payload) {
    state.startDate = payload;
  },
  ENDDATE(state, payload) {
    state.endDate = payload;
  },
  PAGESIZE(state, payload) {
    state.pageSize = payload;
  },
  PAGEINDEX(state, payload) {
    state.pageIndex = payload;
  },
  HISTORYLOADING(state, payload) {
    state.historyLoading = payload;
  },
  [types.GET_MENU_STATUS](state, obj) {
    state.obj = obj;
  },
  [types.GET_STAGE_STATUS](state, obj) {
    state.stageObj = obj;
  },
  SINGLELOGINFLAG(state, payload) {
    state.singleLoginFlag = payload;
  },
  SINGLELOGINLOADING(state, payload) {
    state.singleLoginLoading = payload;
  },
  SINGLELOGINOBJ(state, payload) {
    state.singleLoginObj = payload;
  },
  SINGLELOGINBIDID(state, payload) {
    state.singleLoginBidId = payload;
  },

};

export default {
  namespaced: true,
  modules: {
    toolbar,
  },
  state,
  getters,
  actions,
  mutations,
};
